"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFieldInput = void 0;
var mithril_1 = require("../../mithril");
var theme_1 = require("../theme");
var input_1 = require("./input");
var LocationField_input_style_1 = require("./LocationField.input.style");
var i18n_1 = require("../../i18n");
var services_1 = require("../../services");
var distance_input_1 = require("./distance.input");
var distance_input_state_1 = require("./distance.input.state");
var LocationField_input_state_1 = require("./LocationField.input.state");
(0, theme_1.addStyles)(LocationField_input_style_1.Style);
exports.LocationFieldInput = {
    view: function (state) {
        if (state instanceof LocationField_input_state_1.LocationFieldInputState) {
            return ((0, mithril_1.m)('tr', { className: LocationField_input_style_1.CSS.row }, [
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.label }, (0, i18n_1.Translate)(state.label)),
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.inputs }, [input_1.Input.view(state)]),
                state.hasError() ? (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.MDL.error + ' ' + LocationField_input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)) : null
            ]));
        }
        else if (state instanceof distance_input_state_1.DistanceInputState) {
            return ((0, mithril_1.m)('tr', { className: LocationField_input_style_1.CSS.row }, [
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.label }, (0, i18n_1.Translate)(state.label)),
                (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.inputs }, [distance_input_1.DistanceInput.view(state, services_1.Services.UserSettings.units)]),
                state.hasError() ? (0, mithril_1.m)('td', { className: LocationField_input_style_1.CSS.MDL.error + ' ' + LocationField_input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)) : null
            ]));
        }
        return null;
    }
};
//# sourceMappingURL=LocationField.input.js.map